module.exports = __webpack_public_path__ + "f315161f95c4e4fd90f72c8137658ae9.fbx";